<template>
  <div class="fh-form-subform">
    <fh-subform-content v-bind="$props" @cb="setFull" @updateDataList="updateDataList" />
    <!-- 全屏状态 -->
    <jw-drawer class="ly-sub-form-screen" width="100%" :header="false" :footer="false" :visible="data.fullVisible" unmountOnClose ref="subFormScreen">
      <fh-subform-content v-bind="$props" @cb="setFull" @updateDataList="updateDataList" is-full />
    </jw-drawer>
  </div>
</template>

<script setup>
import { reactive } from 'vue';
import FhSubformContent from './fh-subform-content/fh-subform-content.vue';
defineProps({
  modulesItem: {
    //规则过滤后的表格的字段信息
    type: Object,
    default: () => {
      return {};
    }
  },
  dataList: {
    type: Array,
    default: () => []
  },
  permission: {
    type: Object,
    default: () => {}
  },
  permissionBak: {
    type: Object,
    default: () => {}
  },
  disabledAll: {
    type: Boolean,
    default: false
  },
  from: {
    type: [Number, String],
    default: ''
  },
  type: {
    type: [Number, String],
    default: ''
  },
  copy: {
    //1：复制
    type: Number,
    default: null
  },
  entity: {
    type: Number || String,
    default: null
  },
  mainForm: {
    //主表数据
    type: Array,
    default: () => []
  }
});
const emits = defineEmits(['updateDataList']);
const data = reactive({
  fullVisible: false
});
const updateDataList = (dl) => {
  emits('updateDataList', dl);
};
const setFull = () => {
  data.fullVisible = !data.fullVisible;
};
</script>

<style scoped lang="less">
@import './fh-form-subform.less';
</style>
